import {ChangeDetectorRef, Component, forwardRef, HostListener} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractSwitchInput} from "../abstract-switch-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIInlineSwitchInputComponent),
            multi: true
        }
    ],
    selector: "fui-inline-switch-input",
    templateUrl: "./inline-switch-input.component.html"
})
export class FUIInlineSwitchInputComponent extends FUIAbstractSwitchInput {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }
}
